import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=81c60bb8&"
import script from "./ProductHeader.vue?vue&type=script&lang=js&"
export * from "./ProductHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports